// Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See LICENSE.txt for license information.

import React from 'react';

export default () => (
    <svg
        width='104'
        height='104'
        viewBox='0 0 104 104'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
    >
        <path
            d='M56.0038 86.2168C54.4665 88.5698 50.995 88.909 48.2957 87.0036L17.8171 65.5384C16.8225 64.8673 16.1254 63.838 15.8713 62.6654C15.6171 61.4928 15.8255 60.2673 16.453 59.2446L43.2653 18.2847C44.005 17.2775 45.066 16.5527 46.2732 16.2299C47.4804 15.9071 48.7615 16.0056 49.9052 16.5091L84.5049 31.7311C87.565 33.0808 88.8353 36.0617 87.3124 38.4507L56.0038 86.2168Z'
            fill='#FFBC1F'
        />
        <path
            d='M51.1532 83.4309L19.7363 61.9513L47.3713 19.7427L82.3824 35.7297L51.1532 83.4309Z'
            fill='white'
        />
        <path
            d='M71.0443 32.7343C70.7753 33.0723 70.398 33.3072 69.9759 33.3992C69.5538 33.4913 69.1129 33.4348 68.7276 33.2395L55.5128 27.0324C55.3417 26.97 55.1867 26.8701 55.0593 26.74C54.9318 26.6098 54.8352 26.4528 54.7763 26.2805C54.7175 26.1081 54.698 25.9248 54.7193 25.7439C54.7406 25.563 54.8021 25.3892 54.8993 25.2352L56.9706 22.0667C57.2153 21.7425 57.5641 21.5125 57.9584 21.4152C58.3527 21.318 58.7685 21.3594 59.1358 21.5326L72.5239 27.4799C72.7097 27.5394 72.8797 27.6401 73.0212 27.7743C73.1628 27.9086 73.2723 28.0729 73.3416 28.2553C73.4109 28.4376 73.4383 28.6332 73.4217 28.8276C73.4051 29.022 73.3449 29.2102 73.2457 29.3781L71.0443 32.7343Z'
            fill='#8D93A5'
        />
        <path
            d='M68.5184 28.6204L60.002 24.7517L62.1022 21.5399C62.3517 21.2219 62.6999 20.9961 63.092 20.8981C63.4841 20.8 63.8977 20.8354 64.2674 20.9986L69.933 23.4526C70.1169 23.5088 70.2856 23.606 70.4265 23.7369C70.5673 23.8678 70.6767 24.029 70.7462 24.2083C70.8156 24.3876 70.8435 24.5804 70.8277 24.772C70.8118 24.9637 70.7527 25.1492 70.6547 25.3147L68.5184 28.6204Z'
            fill='#2D3039'
        />
        <path
            d='M69.14 46.0219L51.4648 36.9493L52.3887 35.5347L70.1288 44.5134L69.14 46.0219Z'
            fill='#3DB887'
        />
        <path
            d='M45.8924 36.0254C45.8511 36.0522 45.8042 36.0693 45.7553 36.0753C45.7064 36.0813 45.6568 36.0761 45.6102 36.0601C45.5636 36.0441 45.5213 36.0177 45.4864 35.9829C45.4515 35.9482 45.425 35.9059 45.4088 35.8594L44.3262 32.6548C44.3123 32.6067 44.3089 32.5562 44.3163 32.5067C44.3238 32.4573 44.3418 32.41 44.3692 32.3682C44.3966 32.3263 44.4328 32.2909 44.4752 32.2644C44.5176 32.2379 44.5653 32.2209 44.6149 32.2145L45.0263 32.1279C45.1333 32.1054 45.2448 32.1203 45.342 32.1703C45.4393 32.2202 45.5163 32.3021 45.5604 32.4022L46.1378 34.0767C46.153 34.123 46.1787 34.1652 46.2129 34.2C46.2471 34.2348 46.2888 34.2613 46.3349 34.2773C46.381 34.2934 46.4302 34.2986 46.4786 34.2926C46.527 34.2866 46.5734 34.2695 46.6141 34.2426L49.8907 32.3949C49.9925 32.3434 50.1085 32.3268 50.2206 32.3476C50.3328 32.3685 50.435 32.4257 50.5115 32.5104L50.7713 32.8208C50.8058 32.8585 50.8311 32.9036 50.8452 32.9527C50.8594 33.0018 50.8621 33.0535 50.853 33.1038C50.8439 33.1541 50.8234 33.2016 50.7929 33.2427C50.7625 33.2837 50.7229 33.3172 50.6774 33.3404L45.8924 36.0254Z'
            fill='#3DB887'
        />
        <path
            d='M63.358 54.8492L46.0293 45.2497L46.9603 43.8279L64.3468 53.3407L63.358 54.8492Z'
            fill='#BABEC9'
        />
        <path
            d='M42.7095 45.5816L37.5996 42.709L40.5443 38.198L45.7191 40.984L42.7095 45.5816Z'
            fill='#BABEC9'
        />
        <path
            d='M57.5766 63.6835L40.6016 53.5427L41.5254 52.1208L58.5654 62.175L57.5766 63.6835Z'
            fill='#BABEC9'
        />
        <path
            d='M37.3252 53.8099L32.3164 50.7713L35.2683 46.2603L40.342 49.2123L37.3252 53.8099Z'
            fill='#BABEC9'
        />
        <path
            d='M51.7953 72.5106L35.1738 61.8358L36.0976 60.4211L52.784 71.0021L51.7953 72.5106Z'
            fill='#BABEC9'
        />
        <path
            d='M31.941 62.0305L27.0332 58.8331L29.9923 54.3293L34.9578 57.4329L31.941 62.0305Z'
            fill='#BABEC9'
        />
    </svg>
);
